import React from 'react';
import PIXELPLAY_LOGO from '../../../../assets/logo-horizontal.svg';
import { useAppStateContext } from '@/shared/hooks';
import { useImmer } from 'use-immer';
import { getGeneralPath } from '@/utils/functions';

export const PageLoading = (props) => {
  const [state, setState] = useImmer({ logoUrl: PIXELPLAY_LOGO });
  const { appState } = useAppStateContext();

  React.useMemo(() => {
    const logoUrl = appState?.localData?.config?.logo;

    if (logoUrl && appState.tid) {
      setState((draft) => {
        draft.logoUrl = getGeneralPath(appState.tid) + logoUrl;
      });
    }
  }, [appState?.localData?.config?.logo]);

  return (
    <div className="relative h-screen flex justify-center items-center bg-background overflow-hidden">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[480px] w-[480px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gradient-brand opacity-10 blur-3xl" />
      <div className="relative z-10 flex flex-col items-center gap-4">
        <img src={state.logoUrl} alt="PixelPlay" className="w-[200px]" />
        <p className="text-[11px] uppercase tracking-[0.25em] text-muted-foreground">
          Make every screen come alive
        </p>
        {props.text && (
          <h4 className="font-display text-2xl font-semibold">{props.text}</h4>
        )}
        <div
          className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"
          role="status"
        ></div>
      </div>
    </div>
  );
};
